import React from "react"
import map from "../../assets/img/TVA-District-Map.png"
import question from "../../assets/img/question.svg"

const expandAbbreviations = (abbreviation) => {

    let expanded = abbreviation;

    switch(abbreviation) {
        case "KY":
            expanded = 'Kentucky';
            break;
        case "AL":
            expanded = "Alabama";
            break;
        case "MS":
            expanded = "Mississippi";
            break;
        case "MTN":
            expanded = "Middle Tennessee";
            break;
        case "SE":
            expanded = "Southeast Tennessee"
            break;
        case "NE":
            expanded = "Northeast Tennessee";
            break;
        case "WTN":
            expanded = "Western Tennessee"
            break;
    }

    return expanded;
}

export const Serviceregions = ({requestedContractor}) => {
    const districts = requestedContractor.contractor.districts_served_value?.split(';').filter((x) => !!x)

    return (
        <div className="active-fac-tab">
            <div className="tab-content-title">
                <h4 className="tab-content-title-text">
                    Service Regions
                </h4>
            </div>

            {(requestedContractor.contractor.districts_served_value) ?
            <div className="service-region-content">
                <ul className="contractor-info-list">  {districts?.map((s, i) => <li key={i}>{expandAbbreviations(s)}</li>)} </ul>
            </div>
            :<p>Contractor has not defined service regions yet, please reach out for more details.</p>}
        </div>
    )
}